import { useRef, useState } from 'react';

import { Button, Col, Row, Table } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useFilters } from 'hooks';
import { Input } from 'components';
import { useGetRelationGroupListQuery } from 'services';
import { isSharedIdentificationFeatureEnabled } from 'constant';
import { TABLE_STICKY } from 'constant/table';

import ArticleGroupModal from '../article-group-modal';

import useColumn from './use-column';

const { Search } = Input;

// Ortak kart kolonları sabit genişlikte ~340px tutar; grup adı ve ana madde dar ekranda kelime ortasından bölünmesin.
const TABLE_SCROLL_X = isSharedIdentificationFeatureEnabled ? 800 : 500;

function ArticleGroupDataTable() {
  const debounce = useRef();
  const { filters, setFilters, apiParams } = useFilters({ page: 1, pageSize: 20, _sort: 'id', _sortDir: 'desc' });
  const { data, isFetching } = useGetRelationGroupListQuery(apiParams);

  const [modalState, setModalState] = useState({ open: false, mode: 'create', initialData: null });

  const handleEdit = (record) => {
    setModalState({
      open: true,
      mode: 'edit',
      initialData: { id: record.id },
    });
  };

  const columns = useColumn({ onEdit: handleEdit });

  const pagination = {
    defaultCurrent: 1,
    defaultPageSize: 20,
    current: filters.page,
    pageSize: filters.pageSize,
    total: data?.['hydra:totalItems'] ?? 0,
    position: ['bottomRight'],
    responsive: true,
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
  };

  const handleTableChange = (tablePagination) => {
    const { current, pageSize } = tablePagination;
    setFilters({
      ...filters,
      page: pageSize === filters.pageSize ? current : 1,
      pageSize,
    });
  };

  const searchName = (text) => {
    clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setFilters({ ...filters, name: text, page: 1 });
    }, 300);
  };

  return (
    <>
      <Row
        justify="space-between"
        align="middle"
        className="gx-mb-3"
      >
        <Col
          xs={14}
          md={11}
        >
          <Search
            name="groupSearch"
            onSearch={searchName}
            defaultValue={filters?.name}
            placeholder="Grup adına göre arayın..."
            allowClear
            enterButton
          />
        </Col>
        <Col className="gx-pr-3">
          <Button
            type="primary"
            className="gx-d-flex gx-align-items-center"
            icon={<PlusOutlined />}
            onClick={() => setModalState({ open: true, mode: 'create', initialData: null })}
          >
            Yeni Grup Oluştur
          </Button>
        </Col>
      </Row>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={data?.['hydra:member']}
        loading={isFetching}
        pagination={pagination}
        onChange={handleTableChange}
        scroll={{ x: TABLE_SCROLL_X }}
        sticky={TABLE_STICKY}
      />
      <ArticleGroupModal
        mode={modalState.mode}
        open={modalState.open}
        initialData={modalState.initialData}
        onClose={() => setModalState({ open: false, mode: 'create', initialData: null })}
      />
    </>
  );
}

export default ArticleGroupDataTable;
